import { IBGParams } from '@bg-shared/integrations/shared/interfaces';

export const validateBgParams = (params: IBGParams): IBGParams | null => {
    if (!document.getElementById(params.containerId)) {
        console.error(
            `BetGames loader: No such HTML element in DOM with containerId "${params.containerId}"`,
        );
        return null;
    }

    return params;
};
